<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import axios from "axios";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "All Clients",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      search_status: false,
      filterdArray: [],
      advancedsearch: {
        search: "",
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      loading: false,
      loadingTime: 0,
      maxLoadingTime: 3,
      // PRINT VISIT REPOTS
      reportdata: {
        all_visits: [],
        title: "",
        visit: "",
        pid: "",
        service: "",
      },

      // END PRINT VISIT REPORTS
      model_id: null,
      title: "All Clients",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Clients",
          href: "#/",
        },
        {
          text: "All Clients",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 25, 50, 100, 200, 1000,10000,100000,1000000],
      filter: null,
      todoFilter: null,
      file: "",
      is_uploading: false,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patientCode",
          sortable: true,
          label: "PATIENT CODE",
        },
        {
          key: "patientName",
          sortable: true,
          label: "PATIENT NAME",
        },
        {
          key: "patientContact",
          sortable: true,
          label: "PATIENT CONTACT",
        },
        {
          key: "patientAddress",
          sortable: true,
          label: "PATIENT ADDRESS",
        },
        {
          key: "age",
          sortable: true,
          label: "AGE",
        },
        {
          key: "gender",
          sortable: true,
          label: "GENDER",
        },

        {
          key: "visits",
          sortable: true,
          label: "VISITS",
        },
        {
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        title: "EDIT PATIENT BIO DATA",
        patient_country: 235,
        country_code: 256,
        gender: "",
        contact: "",
        dob: "",
        name: "",
        address: "",
        nin: "",
        email: "",
      },
      //   ============================= EXPORT ==============================
      json_fields: {
        CODE: "patientCode",
        NAME: "patientName",
        CONATCT: "patientContact",
        Address: "patientAddress",
        VISITS: "visits",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("patients", ["all_patients", "saving_status"]),
    ...mapGetters("countries", ["all_countries"]),
    ...mapGetters("visits", ["OrderedConsultations", "OrderServiceStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**

     * Total no. of records
     */

      totalRecords: function () {
      return this.filterdArray ? this.filterdArray.length : 0;
    },

    rows() {
      return this.filterdArray ? this.filterdArray.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filterdArray ? this.filterdArray.length : 1;
  },
  watch: {
    all_patients(newVal) {
      if (newVal) {
        this.AssignPatient();
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.submitted = false;
          this.$toast.success(this.notification_message.msg);
          this.closeMode(this.model_id);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    Visit_consultations(id) {
      this.FetchOrderedConsultations(id);
    },
    ...mapActions({
      FetchPatients: "patients/fetchPatients",
      FetchActivePatients: "patients/fetchActivePatients",
      FetchCountries: "countries/fetchCountries",
      EditPatients: "patients/editPatients",
      FetchOrderedConsultations: "visits/fetchOrderedConsultations",
    }),

    /**
     * Search the table data with search input
     */
    AssignPatient() {
      this.filterdArray = this.all_patients;
    },
    // END SET PRINT
    SearchPatient() {
      this.search_status = true;
      axios
        .post("search_patient", this.advancedsearch)
        .then((response) => {
          this.search_status = false;
          this.filterdArray = response.data.data;
        })
        .catch(() => {
          this.search_status = false;
        });
    },
    // SET PRINT
    setVisitPrint(data) {
      this.$store.commit("visits/CLEAR_CONS_ARRAY");
      this.reportdata.title = `PRINT VISIT REPORT FOR ${data.patientName}`;
      this.reportdata.all_visits = data.allvisits;
      this.reportdata.pid = data.id;
    },
    Print_visiteport() {
      this.$router.push(
        `/visit_report/${this.reportdata.pid}/${this.reportdata.visit}/${this.reportdata.service}`
      );
    },
    // END SET PRINT
    EditPatientFunc() {
      this.EditPatients(this.data);
    },
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },

    //===========================================
    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    importFile(modelId) {
      this.is_uploading = true;
      let formData = new FormData();
      formData.append("file", this.file);

      const headers = { "Content-Type": "multipart/form-data" };
      axios
        .post("import_clients", formData, { headers })
        .then((res) => {
          this.is_uploading = false;
          this.closeMode(modelId);
          if (res.status == 200) {
            let message = { msg: "Success upload" };
            this.FetchPatients();
            this.closeMode(modelId);
            this.$store.dispatch("notification/success", message);
          } else {
            let message = { msg: "Something went wrong and upload failed" };
            this.$store.dispatch("notification/error", message);
          }
        })
        .catch(() => {
          this.is_uploading = false;
          this.closeMode(modelId);
          let message = { msg: "Something went wrong and upload failed" };
          this.$store.dispatch("notification/error", message);
        });
    },
    resetUploadModal() {},

    setEditValues(patient) {
      this.model_id = "patient_editModel";

      let dataedit = {
        title: `EDIT BIO DATA FOR PATIENT ${patient.patientName.toUpperCase()}`,
        patient_country: patient.country,
        country_code: "",
        gender: patient.gender,
        contact: patient.patientContact,
        dob: patient.DOB,
        name: patient.patientName,
        address: patient.patientAddress,
        nin: patient.NIN,
        email: patient.patientEmail,
        code: patient.patientCode,
        id: patient.id,
      };
      this.data = dataedit;
      this.Set_countrycode();
    },
    // SET COUNTRY CODE

    Set_countrycode() {
      let country = this.all_countries.filter((element) => {
        return element.id == this.data.patient_country;
      });
      this.data.country_code = country[0].dialCode;
    },
    // END SET COUNTRY CODE
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchPatients();
    this.AssignPatient();
    this.FetchCountries();
    // this.FetchActivePatients();
  },
};
</script>

<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="`${title+' - ('+totalRecords+')'} `" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <lable>Filter Start Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date1"
                  class="form-control"
                />
              </div>
              <div class="col-md-2">
                <lable>Filter End Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date2"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <lable>Name/Code/Contact</lable>
                <input
                  type="text"
                  v-model="advancedsearch.search"
                  class="form-control"
                  placeholder="Search name,code or contact"
                />
              </div>
              <div class="col-md-3">
                <br />
                <button v-if="search_status" disabled class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
                <button v-else @click="SearchPatient()" class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
              </div>
            </div>

            <div class="row">
              <div v-if="search_status" class="loader-line"></div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button v-b-modal.upload-modal variant="success"
                    ><i class="fa fa-upload"></i> Import Clients</b-button
                  >
                  |
                  <download-excel
                    class="btn btn-primary mb-1"
                    :data="filterdArray"
                    :fields="json_fields"
                    :worksheet="'All Patients' + currentdate"
                    type="csv"
                    :name="'all_patinet' + currentdate + '.xls'"
                  >
                    <i class="fa fa-download"></i> Export Excel
                  </download-excel>
               
                  <!-- CLIENTS EXCEL UPLOAD MODAL-->
                  <b-modal
                    id="upload-modal"
                    ref="modal"
                    hide-footer
                    title="Upload an excel file of clients"
                    @hidden="resetUploadModal"
                  >
                    <div class="mb-2">
                      <label class="col-form-label" for="upload-file"
                        >Select file to upload:</label
                      >
                      <input
                        id="upload-file"
                        class="form-control"
                        type="file"
                        ref="file"
                        @change="handleUpload"
                      />
                    </div>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('upload-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="importFile('upload-modal')"
                      >
                        Import Clients
                        <b-spinner
                          v-if="is_uploading"
                          variant="light"
                          small
                          role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filterdArray ? filterdArray : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(gender)="data">
                  {{ data.item.gender == 1 ? "Male" : "Female" }}
                </template>

                <template #cell(actions)="data">
                  <button
                    v-if="user_permissions.edit_visit"
                    @click="setEditValues(data.item)"
                    v-b-modal.patient_editModel
                    class="btn btn-primary btn-sm m-1"
                  >
                    <i class="fa fa-edit"></i> Edit
                  </button>
                  <button
                    v-else
                    class="btn btn-outline-primary btn-sm m-1"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Edit
                  </button>
                  <router-link
                    v-if="user_permissions.client_profile"
                    class="btn btn-info btn-sm"
                    :to="{
                      name: 'PatientProfile',
                      params: { patient_id: data.item.id },
                    }"
                  >
                    <i class="fa fa-eye"></i> Profile
                  </router-link>
                  <button
                    v-else
                    class="btn btn-outline-info btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Profile
                  </button>
                  <button
                    v-if="user_permissions.print_patient_report"
                    @click="setVisitPrint(data.item)"
                    v-b-modal.reportmodel
                    class="btn btn-success btn-sm m-1"
                  >
                    Report
                  </button>
                  <button
                    v-else
                    class="btn btn-outline-success btn-sm m-1"
                    title="You are restricted"
                  >
                    Report
                  </button>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!all_patients" class="text-primary">
                  <b-spinner
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- START MODEL FOR EDITING A PATIENT -->

          <b-modal
            id="patient_editModel"
            size="lg"
            :title="data.title"
            title-class="font-18"
            ok-title="Submit"
            hide-footer
          >
            <div class="row mt-2">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">NAME</label>
                  <input
                    v-model="data.name"
                    placeholder="Enter name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">EMAIL</label>
                  <input
                    v-model="data.email"
                    placeholder="Enter email"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">COUNTRY</label>
                  <model-list-select
                    @input="Set_countrycode"
                    :list="
                      $store.state.countries.countries.data
                        ? $store.state.countries.countries.data
                        : []
                    "
                    v-model="data.patient_country"
                    option-value="id"
                    option-text="countryName"
                    placeholder="select Country"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">CONTACT</label>

                  <div class="input-group">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      id="inputGroupFileAddon03"
                    >
                      +{{ data.country_code }}
                    </button>
                    <input
                      id="contact"
                      type="text"
                      v-model="data.contact"
                      name="contact"
                      autocomplete="off"
                      class="form-control"
                      placeholder="Enter contact"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">NIN</label>
                  <input
                    v-model="data.nin"
                    placeholder="Enter NIN"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">DATE OF BIRTH</label>
                  <input
                    v-model="data.dob"
                    placeholder="Enter date of birth"
                    type="date"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">GENDER</label>
                  <select class="form-control" v-model="data.gender">
                    <option value="">Select gender</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">PATIENT ADDRESS</label>
                  <input
                    v-model="data.address"
                    placeholder="Enter address"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <br />
            <br />
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary float-start"
                @click="closeMode('patient_editModel')"
              >
                cancel
              </button>
              <button
                type="submit"
                @click="EditPatientFunc()"
                class="btn btn-success"
              >
                SAVE <i class="fa fa-check"></i>
              </button>
              <b-spinner
                v-if="saving_status"
                style="float: right"
                class="m-2"
                variant="primary"
                role="status"
              ></b-spinner>
            </div>
          </b-modal>
          <!-- END EDIT MODEL -->

          <!-- REPORT MODEL -->
          <b-modal
            id="reportmodel"
            hide-footer
            :title="reportdata.title ? reportdata.title : '--'"
          >
            <div class="form-group">
              <label>Select a visit date to print</label>

              <model-list-select
                :list="reportdata.all_visits ? reportdata.all_visits : []"
                v-model="reportdata.visit"
                option-value="id"
                @input="Visit_consultations($event)"
                option-text="visit_date"
                placeholder="select Visit date to be printed"
              >
              </model-list-select>
            </div>

            <div
              class="form-group mt-3"
              v-if="OrderedConsultations && !OrderServiceStatus"
            >
              <label
                >Select a service to print from the visit selected above</label
              >
              <select class="form-control" v-model="reportdata.service">
                <option>Select a service to print Report</option>
                <option
                  v-for="(serve, i) in OrderedConsultations
                    ? OrderedConsultations
                    : []"
                  :key="i"
                  :value="serve.service.id"
                >
                  {{ serve.service.name }}
                </option>
              </select>
            </div>
            <div
              v-else-if="!OrderedConsultations && OrderServiceStatus"
              class="loader-line"
            ></div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary float-start"
                @click="closeMode('reportmodel')"
              >
                cancel
              </button>
              <button
                @click="Print_visiteport()"
                type="submit"
                class="btn btn-success"
              >
                PRINT <i class="fa fa-print"></i>
              </button>
            </div>
          </b-modal>
          <!-- END REPORT MODEL -->
        </div>
      </div>
    </div>
  </Layout>
</template>
